import { useState, useEffect, useRef, useCallback } from "react";

export function ScrollProgress() {
  const [progress, setProgress] = useState(0);
  const ticking = useRef(false);

  const updateProgress = useCallback(() => {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
    setProgress(scrollPercent);
    ticking.current = false;
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!ticking.current) {
        ticking.current = true;
        requestAnimationFrame(updateProgress);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    updateProgress(); // Initial calculation

    return () => window.removeEventListener("scroll", handleScroll);
  }, [updateProgress]);

  return (
    <div
      className="fixed top-0 left-0 h-1 bg-gradient-to-r from-accent via-primary to-accent z-[100] transition-transform duration-75"
      style={{ 
        width: "100%",
        transform: `scaleX(${progress / 100})`,
        transformOrigin: "left"
      }}
    />
  );
}
